import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import Cookies from "js-cookie";
import { readRefreshToken, refreshOnce } from "./refreshSession";

const SIX_HOURS = 6 * 60 * 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;

function accessExpiresSoon() {
  const token = Cookies.get("token-siraj");
  if (!token) return true;
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const data = JSON.parse(atob(payload));
    return data.exp * 1000 - Date.now() < ONE_HOUR;
  } catch (error) {
    return false;
  }
}

export default function SessionGate({ children }) {
  const isAuthenticated = useIsAuthenticated();
  const [ready, setReady] = useState(
    () => isAuthenticated() || !readRefreshToken()
  );

  useEffect(() => {
    let cancelled = false;
    if (isAuthenticated() || !readRefreshToken()) {
      setReady(true);
      return undefined;
    }
    refreshOnce()
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!ready || !isAuthenticated()) return undefined;

    const refreshIfNeeded = () => {
      if (document.visibilityState === "hidden") return;
      if (!readRefreshToken() || !accessExpiresSoon()) return;
      refreshOnce().catch(() => {});
    };

    const intervalId = window.setInterval(() => {
      refreshOnce().catch(() => {});
    }, SIX_HOURS);
    document.addEventListener("visibilitychange", refreshIfNeeded);

    return () => {
      window.clearInterval(intervalId);
      document.removeEventListener("visibilitychange", refreshIfNeeded);
    };
  }, [ready]);

  if (!ready) return null;
  return children;
}

SessionGate.propTypes = {
  children: PropTypes.node,
};
